// src/components/ui/skeleton.js
import React from "react";

export function Skeleton({ className, ...props }) {
  return (
    <div
      className={`animate-pulse bg-gray-200 rounded-md ${className || ""}`}
      {...props}
    />
  );
}
